var React = require('react');

function UpRight (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.71","y1":"23.28","x2":"22.87","y2":"1.1","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"23.89","y1":"1","x2":"7.97","y2":"1","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"2","key":1}),React.createElement("line",{"x1":"22.96","x2":"22.96","y2":"16","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"2","key":2})]);
}

UpRight.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 23.96 23.99"};

module.exports = UpRight;

UpRight.default = UpRight;
